import script from "./RatingSkillsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingSkillsModal.vue?vue&type=script&setup=true&lang=js"

import "./RatingSkillsModal.vue?vue&type=style&index=0&id=0099df40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0099df40"]])

export default __exports__